import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientRecalculationDoses(patientId: string | undefined) {
  return useQuery(queries.patients.getPatientRecalculationDoses(patientId || ''))
}
